var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRewardF = function SvgRewardF(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1724213012791,
    className: "icon",
    viewBox: "0 0 1024 1024",
    "p-id": 6324,
    width: 32,
    height: 32,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M859.7 778.7l-95.6-165.5c44-56 67.9-124.7 67.9-197.1 0-85.5-33.3-165.8-93.7-226.3C677.8 129.3 597.5 96 512 96c-85.5 0-165.8 33.3-226.3 93.7C225.3 250.2 192 330.5 192 416c0 79.1 28.5 153.8 80.7 212.4L186 778.7c-10.9 18.9-9.4 42.3 3.9 59.6 13.3 17.3 35.5 24.8 56.5 19.2l56.9-15.2 15.2 56.8c5.6 21.1 23.3 36.5 44.9 39.4 2.4 0.3 4.7 0.5 7.1 0.5 19 0 36.7-10.1 46.5-26.9l101.7-176.1c2.8-0.1 5.6-0.1 8.4-0.3L628.8 912c9.7 16.8 27.4 26.9 46.4 26.9 2.3 0 4.7-0.2 7.1-0.5 21.6-2.8 39.2-18.3 44.9-39.4l15.2-56.9 56.8 15.2c21.1 5.6 43.3-1.9 56.5-19.2S870.6 797.5 859.7 778.7zM331 235c48.4-48.4 112.6-75 181-75 68.4 0 132.7 26.6 181 75 48.4 48.4 75 112.6 75 181 0 56.4-18.2 110.1-51.7 154.3l-15.4 17c-41.5 45.8-98.6 74.9-160.7 81.8l-22.6 2.5-15.7-0.6c-62.9-2.5-122.3-27.6-167.1-70.7l-11.1-10.7C280 542.1 256 480.9 256 416 256 347.6 282.6 283.3 331 235zM373.9 858.5l-13.8-51.4c-3.1-11.6-10.5-21.2-20.9-27.2-6.9-4-14.6-6-22.3-6-3.9 0-7.8 0.5-11.7 1.5l-51.4 13.8L321 672.8c37.9 28.3 81.2 47.6 127.3 56.9L373.9 858.5zM740.4 775.4c-23.8-6.4-48.5 7.8-54.9 31.7l-13.8 51.5-77-133.3c45-12 86.9-33.7 123-64.2l74 128.2L740.4 775.4z",
    "p-id": 6325,
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M512 560c79.4 0 144-64.6 144-144s-64.6-144-144-144c-79.4 0-144 64.6-144 144S432.6 560 512 560zM512 336c44.1 0 80 35.9 80 80s-35.9 80-80 80-80-35.9-80-80S467.9 336 512 336z",
    "p-id": 6326,
    fill: "#ffffff"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRewardF, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/reward_f.4a8bb9f5.svg";
export { ForwardRef as ReactComponent };